import React, { useEffect, useState } from 'react'
import { Button, Typography } from '@mui/material'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { SmartDialog } from '../utilities/SmartDialog'
import AlertUI from '../AlertUI'
import { useSmartTranslation } from '../hooks/useSmartTranslation'
import NonDeletableItemsData from './NonDeletableItemsData'

const NonDeletableItemsDataShowAlert = ({
  deleteResponse,
  allItems,
  property,
  allSelected
}) => {
  const { t_ } = useSmartTranslation()
  const [AlertElement, showAlert] = AlertUI()
  const [openSmartDialog, setOpenSmartDialog] = useState(false)

  useEffect(() => {
    if (deleteResponse === null) return

    const getAlert = (responseLength, isAllSelected) => {
      if (responseLength === 0) {
        return {
          title: t_('Deleted correctly.'),
          severity: 'success'
        }
      }
      if (isAllSelected) {
        return {
          title: '',
          message: t_('One or more items can\'t be deleted because they are already in use.'),
          severity: 'error'
        }
      }
      const plural = responseLength > 1 ? 's' : ''

      const message = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>
            {t_(`The item${plural ? 's' : ''} could not be deleted because ${plural ? 'they are' : 'it is'} already in use.`)}
          </span>
          <Button
            onClick={() => setOpenSmartDialog(true)}
            style={{ padding: '0 1px', minWidth: 'auto' }}
          >
            <span>{t_('Show details')}</span>
          </Button>
        </div>
      )

      return {
        title: '',
        message,
        severity: 'error'
      }
    }

    showAlert(getAlert(deleteResponse.length, allSelected))
  }, [deleteResponse, showAlert, setOpenSmartDialog, t_, allSelected])

  const handleExit = () => setOpenSmartDialog(false)

  return (
    <>
      <SmartDialog
        title={{ icon: <DeleteForeverIcon fontSize='large' color='primary' />, render: <Typography variant='h4'>{t_('Elements with dependencies')}</Typography> }}
        closeCallback={handleExit}
        accept
        acceptCallback={handleExit}
        cancel={false}
        close
        setOpen={openSmartDialog}
        renderComponent={
          <NonDeletableItemsData domainUsageList={deleteResponse} fullList={allItems} property={property} />
        }
      />
      {AlertElement}
    </>
  )
}
export default NonDeletableItemsDataShowAlert
